import React, { useContext } from "react"
import FlowObject from "../../model/FlowObject"
import ImageFlowObject from "../../model/ImageFlowObject"
import { Spacer } from "./Spacer"
import { SET_POSITION, DELEGATE, SET_SIZE } from "../fsm/types"
import { MachineContext } from "../fsm/useMachine"
import {Crosshair} from "react-feather"
import XYIcon from "../icons/XYIcon"
import { Tooltip } from "@material-ui/core"

interface Props {
    currObject: FlowObject
}

export const LocationControls: React.FC<Props> = ({ currObject }) => {
    const [, send] = useContext(MachineContext)
    const [state, setState] = React.useState({
        x: Math.round(currObject.frame.x) || 0,
        y: Math.round(currObject.frame.y) || 0,
        width: Math.round(currObject.frame.width) || 0,
        height: Math.round(currObject.frame.height) || 0
    })

    React.useEffect(() => {
        setState({
            x: Math.round(currObject.frame.x) || 0,
            y: Math.round(currObject.frame.y) || 0,
            width: Math.round(currObject.frame.width) || 0,
            height: Math.round(currObject.frame.height) || 0
        })
    }, [currObject.frame])

    const onChange = (e: React.ChangeEvent<HTMLInputElement>, val: any) => {
        send({ type: "MARK_ACTIVE", id: e.currentTarget.id })
        e.preventDefault()
        e.stopPropagation()
        let newVals = { ...state, ...val }
        setState(s => ({ ...s, ...val }))
        send({ type: DELEGATE, payload: { type: SET_SIZE, width: newVals.width, height: newVals.height, }, id: currObject.id })
        send({ type: DELEGATE, payload: { type: SET_POSITION, x: newVals.x, y: newVals.y, }, id: currObject.id })
        send({ type: "MARK_INACTIVE" })
    }

    /**
     * Set currObjects `frame.height` value to match input
     * @param e: current event
     */
    const setScale = (e: React.ChangeEvent<HTMLInputElement>) => {
        // context.toggleTextBoxActive()
        // context.setAllowDelete(false)
        // e.preventDefault()
        // e.stopPropagation()
        // const currObject = context.currentObject
        // const origScale = _cloneDeep(currObject.zoomScale)
        // const origRotation = _cloneDeep(currObject.rotation)
        // const eVal = parseInt(e.currentTarget.value) || 0
        // const newVal = eVal > 1 ? eVal / 100 : eVal
        // currObject.setScale(newVal)
        // let evt = new TransformEvent(
        //   { id: currObject.id, screen: context.index },
        //   { zoomScale: origScale, rotation: origRotation },
        //   currObject,
        //   { zoomScale: currObject.zoomScale, rotation: currObject.rotation },
        // )
        // context.registerEvent(evt)
        // context.focusOnObject(context.currentObject)
        // context.toggleTextBoxActive()
    }

    return (
        <div className="location-controls-wrapper">
            <div
                id="locationControls"
                className="locationControls white"
            >
                <form>                
                <Tooltip title="Location of Object">
                    <Crosshair
                        className="margin_left feather"                                                
                        style={{paddingTop: '7.5px', marginTop: '5px'}}
                    />
                </Tooltip>                                                                   
                <Spacer width={3} height={32} />
                <label title="Change X Position">
                    {" "}
          X{" "}
                    <input
                        className="location-input"
                        size={4}
                        id="mmo_x"
                        onFocus={(e) => {
                            send({ type: "MARK_ACTIVE", id: e.currentTarget.id })
                        }}
                        onChange={(e) => onChange(e, { x: parseInt(e.currentTarget.value) || 0 })}
                        onBlur={() => send({ type: "MARK_INACTIVE" })}
                        pattern={"[+-]?([0-9]*[.])?[0-9]+"}
                        type="text"
                        value={state.x}
                    />
                </label>
                <label title="Change Y Position">
                    {" "}
          Y{" "}
                    <input
                        size={4}
                        className="location-input"
                        id="mmo_y"
                        onFocus={(e) => {
                            send({ type: "MARK_ACTIVE", id: e.currentTarget.id })
                        }}
                        onBlur={() => send({ type: "MARK_INACTIVE" })}
                        onChange={(e) => onChange(e, { y: parseInt(e.currentTarget.value) || 0 })}
                        pattern={"[+-]?([0-9]*[.])?[0-9]+"}
                        type="test"
                        value={state.y}
                    />
                </label>
                
                <Spacer width={20} height={32} />
                <Tooltip title="Dimensions" style={{paddingTop: '7.5px', marginTop: '5px'}} >
                <XYIcon  />
                </Tooltip>
                <label title="Change Width">
                    {" "}
          W{" "}
                    <input
                        className="location-input"
                        size={4}
                        id="mmo_w"
                        onFocus={(e) => {
                            send({ type: "MARK_ACTIVE", id: e.currentTarget.id })
                        }}
                        onBlur={() => send({ type: "MARK_INACTIVE" })}
                        onChange={(e) => onChange(e, { width: parseInt(e.currentTarget.value) || 0 })}
                        pattern={"[+-]?([0-9]*[.])?[0-9]+"}
                        type="text"
                        value={state.width}
                    />
                </label>
                <label title="Change Height">
                    {" "}
          H{" "}
                    <input
                        className="location-input"
                        size={4}
                        id="mmo_h"
                        onFocus={(e) => {
                            send({ type: "MARK_ACTIVE", id: e.currentTarget.id })
                        }}
                        onBlur={() => send({ type: "MARK_INACTIVE" })}
                        onChange={(e) => onChange(e, { height: parseInt(e.currentTarget.value) || 0 })}
                        pattern={"[+-]?([0-9]*[.])?[0-9]+"}
                        type="text"
                        value={state.height}
                    />
                </label>
                <Spacer width={20} height={32} />
            </form>
            </div>
        </div>
    )
}

// TODO: Figure out when to use scale.
// {
//     currObject && (currObject as ImageFlowObject) && (
//         <label title="Change Scale">
//             {" "}
//             %{" "}
//             <input
//                 className="location-input"
//                 size={4}
//                 id="mmo_s"
//                 onChange={setScale}
//                 pattern={"[+-]?([0-9]*[.])?[0-9]+"}
//                 type="text"
//                 value={
//                     currObject != null && (currObject as ImageFlowObject)
//                         ? Math.round(currObject.zoomScale * 100)
//                         : 0
//                 }
//             />
//         </label>
//     )
// }

LocationControls.displayName = "LocationControls"
export default LocationControls
